import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

type C1ChipTone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger';

interface C1ChipProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  tone?: C1ChipTone;
}

/** Small status pill. Pair colour with words — never colour alone. */
export function C1Chip({ children, tone = 'neutral', className, ...props }: C1ChipProps) {
  return (
    <span className={cx('c1-chip', tone !== 'neutral' && `c1-chip--${tone}`, className)} {...props}>
      {children}
    </span>
  );
}
